













































import Vue from "vue";
import sshDataProvider from "@/services/ssh-server/defaultDataProvider";
const dataProvider = sshDataProvider();

export default Vue.extend({
  data() {
    return {
      search: "",
      headers: [
        {
          text: "Name",
          align: "start",
          sortable: false,
          value: "name",
        },
        {
          text: "Host",
          sortable: false,
          value: "host",
        },
        {
          text: "Type",
          sortable: false,
          value: "type",
        },
        {
          text: "Status",
          sortable: false,
          value: "disabled",
        },
        {
          text: "Action",
          align: "end",
          value: "action",
          sortable: false,
        },
      ],
      dataTable: [],
    };
  },
  methods: {
    connectResource(item) {
      const routeData = this.$router.resolve({
        name: 'connection',
        query: {ip: item.common_properties.host}
      });
      window.open(routeData.href, '_blank');
    },
    async getData() {
      const {body} = await dataProvider.execute("GetAuthorizedResources", {});
      if (body && body.data && body.data.length > 0) {
        this.dataTable = body.data
      }
    }
  },
  created() {
    this.getData()
  },
});
